/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { GeometryFromJSONTyped, GeometryToJSON, } from './Geometry';
/**
 * Check if a given object implements the BountyLocation interface.
 */
export function instanceOfBountyLocation(value) {
    let isInstance = true;
    return isInstance;
}
export function BountyLocationFromJSON(json) {
    return BountyLocationFromJSONTyped(json, false);
}
export function BountyLocationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return Object.assign(Object.assign({}, GeometryFromJSONTyped(json, ignoreDiscriminator)), { 'coordinates': !exists(json, 'coordinates') ? undefined : json['coordinates'] });
}
export function BountyLocationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return Object.assign(Object.assign({}, GeometryToJSON(value)), { 'coordinates': value.coordinates });
}
